import React, { useState } from "react";

import { LivePanel } from "@demo/ui/LivePanel.js";
import { MatterTimeline } from "@demo/ui/MatterTimeline.js";
import { LEGAL_GIG_CATALOG } from "@demo/live/gig-catalog-legal.js";
import { SPAULDING_OAKES } from "./scenario/spauldingoakes.js";
import { LEGAL_BUNDLES } from "./data.js";

// The Spaulding & Oakes app leads with an Overview — the matter-file timeline, a
// distinct layout from the other demos — with the live seal behind a second
// tab. Everything below the masthead is shared UI driven by the firm's copy;
// the recorded receipts the Overview verifies are two real four-step execution
// records (apps/legal-demo/src/data.ts).
type Mode = "overview" | "live";

export function App() {
  const [mode, setMode] = useState<Mode>("overview");

  return (
    <div className="page">
      <div className="disclosure-banner" role="note">
        <span className="disclosure-dot" aria-hidden="true" />
        <span>{SPAULDING_OAKES.disclosure}</span>
      </div>

      <header className="masthead">
        <div className="brand">
          <span className="brand-mark" aria-hidden="true">
            {SPAULDING_OAKES.client.mark}
          </span>
          <div>
            <div className="brand-name">{SPAULDING_OAKES.client.name}</div>
            <div className="brand-domain">{SPAULDING_OAKES.client.domain}</div>
          </div>
        </div>
        <div className="masthead-tag">{SPAULDING_OAKES.masthead}</div>
      </header>

      <div className="mode-toggle" role="tablist" aria-label="Demo section">
        <button
          role="tab"
          aria-selected={mode === "overview"}
          className={"mode-toggle-btn" + (mode === "overview" ? " mode-toggle-btn-active" : "")}
          onClick={() => setMode("overview")}
        >
          Overview
        </button>
        <button
          role="tab"
          aria-selected={mode === "live"}
          className={"mode-toggle-btn" + (mode === "live" ? " mode-toggle-btn-active" : "")}
          onClick={() => setMode("live")}
        >
          Run live
        </button>
      </div>

      {mode === "overview" ? (
        <main className="content">
          <MatterTimeline
            config={SPAULDING_OAKES.timeline}
            bundles={LEGAL_BUNDLES}
            ctas={[{ ...SPAULDING_OAKES.liveCta, onClick: () => setMode("live") }]}
          />
        </main>
      ) : (
        <main className="content">
          <section className="intro">
            <h1>{SPAULDING_OAKES.intro.headline}</h1>
            <p>{SPAULDING_OAKES.intro.body}</p>
          </section>

          <LivePanel catalog={LEGAL_GIG_CATALOG} copy={SPAULDING_OAKES.live} />
        </main>
      )}

      <footer className="footer">
        <p>
          {SPAULDING_OAKES.disclosure} Built on{" "}
          <span className="footer-link">{SPAULDING_OAKES.product.name}</span>:{" "}
          {SPAULDING_OAKES.product.tagline}.
        </p>
      </footer>
    </div>
  );
}
